import get from 'lodash/get';
import moment from 'moment';
import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import * as api from 'dashboard/resources/self-service-out-of-stock.api';
import template from './self-service-out-of-stock-widget.html';
import chartConfig from './self-service-out-of-stock-chart-config.json';
import { extendChartConfig, parseTimeToHoursAndMinutes } from './self-service-out-of-stock-widget-service';

const mapStateToThis = ({ session, config }) => {
  const { retailer } = session;
  const { colorScale } = config;

  return {
    retailer,
    colorScale,
  };
};

const mapDispatchToThis = {};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', 'gettextCatalog')
class SelfServiceOutOfStockWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.lost = 0;
    this.time = 0;
    this.factor = 0;
    this.timeToDisplay = '';
    this.downloadData = {
      fileName: 'Details',
    };
    this.retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.loadDataAsync(() => api.fetchSelfServiceOutOfStock(this.retailerId), this.transformData.bind(this), 'content.content');
  }

  $onDestroy() {
    this.unsubscribe();
  }

  transformData(data) {
    let transformedData = get(data, 'content.content') || [];
    // sort by date
    transformedData = transformedData.sort((week1, week2) => {
      if (moment(week1.weekEndDate).isSame(week2.weekEndDate)) {
        return 0;
      }
      if (moment(week1.weekEndDate).isBefore(week2.weekEndDate)) {
        return -1;
      }
      return 1;
    });

    this.chartOptions = extendChartConfig(
      chartConfig,
      this.gettextCatalog,
      this.colorScale.find((color) => color.id === 'CHAIN_HEAD').label
    );
    this.chartModel = [
      {
        values: transformedData,
      },
    ];

    transformedData.forEach(({ estLostSales, timeNotSelling, oosFactor }) => {
      if (estLostSales || timeNotSelling || oosFactor) {
        this.isEmpty = false;
        this.lost += estLostSales;
        this.time += timeNotSelling;
        this.factor += oosFactor;
      }
    });

    this.timeToDisplay = parseTimeToHoursAndMinutes(this.time);
    // calculating average for the 13 weeks period
    if (transformedData.length > 0 && this.factor > 0) {
      this.factor /= transformedData.length;
    }

    return transformedData;
  }

  onDownloadReport() {
    return api.downloadLvmReport(this.retailerId);
  }
}

export default class SelfServiceOutOfStockWidgetComponent {
  constructor() {
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
    this.controller = SelfServiceOutOfStockWidgetController;
    this.template = template;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/self-service-out-of-stock/self-service-out-of-stock-widget-component.js